import { getAccessToken } from "./utils";
import { getUrl } from "./urls";
import axios from "axios";
import moment from "moment-timezone";
import store from "../store";
import { downloadCSVData } from "../components/MainContent/Dashboard/Charts/utils";

export const FETCH_LOGINLOGS_LIST = "FETCH_LOGINLOGS_LIST";
export const FETCH_DOWNLOADLOGINLOGS_LIST = "FETCH_DOWNLOADLOGINLOGS_LIST";

export const fetchLoginLogsList = (start, end, offsetValue, pagination = false) => {
    //  console.log("did2", start, end);
    let url = `${getUrl("login-logs")}?access-token=${getAccessToken()}`;

    const userTimezone = store.getState().globalReducer.company.user_timezone_name;

    let data = {
        records_per_page: 500,
        offset: offsetValue > 0 ? offsetValue : 0,
    };

    if (start && end) {
        data.start_date = moment(start).startOf("day").format("YYYY-MM-DDTHH:mm:ss");
        data.end_date = moment(end).endOf("day").format("YYYY-MM-DDTHH:mm:ss");

        // console.log("did3", data.start_date, data.end_date);
        // console.log("did4", userTimezone);
    }

    let req = axios({
        method: "post",
        url,
        data,

        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return { ...res.data, pagination };
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_LOGINLOGS_LIST,
        payload: req,
    };
};

export const downloadCSVLoginLogsList = (start, end, pages) => {
    let url = `${getUrl("login-logs")}?access-token=${getAccessToken()}`;

    const userTimezone = store.getState().globalReducer.company.user_timezone_name;

    let data = {
        records_per_page: pages,
        offset: 0,
    };

    if (start && end) {
        data.start_date = moment(start).startOf("day").format("YYYY-MM-DDTHH:mm:ss");
        data.end_date = moment(end).endOf("day").format("YYYY-MM-DDTHH:mm:ss");
    }

    let req = axios({
        method: "post",
        url,
        data,

        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            let csvFmt = [["USER", "EMAIL", "DATE"]];

            let data = res.data.data;
            let maskEmail = (email = "") => {
                const [name, domain] = email.split("@");
                const { length: len } = name;
                const maskedName = name[0] + "*****" + name[len - 1];
                const [domain1, domain2] = domain.split(".");
                const maskedDomain = domain1[0] + "****" + ".";
                const maskedEmail = maskedName + "@" + maskedDomain + domain2;
                return maskedEmail;
            };

            data.map((p, i) => {
                csvFmt.push([p.user.name, maskEmail(p.user.email), moment(p.date_time).tz(userTimezone).format("YYYY-MM-DD HH:mm:ss z")]);
            });
            // console.log("data", csvFmt);
            downloadCSVData(csvFmt, "LOGIN-LOGS DETAILS");

            return data;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_DOWNLOADLOGINLOGS_LIST,
        payload: req,
    };
};
